import AvatarCard from "@/ui/avatar-card";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox, Text } from "rizzui";
import { Service, SystemSetting } from "@/types";
import { HOST_API_URL } from "config";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import routes from "@/routers/routes";

const columnHelper = createColumnHelper<Service>();

export const serviceListColumns = [
    columnHelper.display({
        id: "select",
        size: 50,
        header: ({ table }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select all Rows"
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => table.toggleAllPageRowsSelected()}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select Row"
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        ),
    }),
    columnHelper.accessor("name", {
        id: "name",
        size: 150,
        header: "Name",
        enableSorting: false,
        cell: ({ row }) => (
            <AvatarCard
                src={
                    HOST_API_URL.replace("api", "") +
                        "/" +
                        row.original?.image
                            ?.replace("wwwroot\\", "")
                            .replace(/\\/g, "/") || "icon"
                }
                name={row.original.name}
            />
        ),
    }),
    columnHelper.accessor("subTitle", {
        id: "subTitle",
        size: 150,
        header: "SubTitle",
        enableSorting: false,
        cell: ({ row }) => <Text>{row.original.subTitle}</Text>,
    }),
    columnHelper.accessor("description", {
        id: "description",
        size: 150,
        header: "Description",
        enableSorting: false,
        cell: ({ row }) => <Text>{row.original.subTitle}</Text>,
    }),
    columnHelper.display({
        id: "actions",
        size: 120,
        cell: ({
            row,
            table: {
                options: { meta},
            },
        }) => (
            <TableRowActionGroup
                deletePopoverTitle="Delete the Service"
                onDelete={() => {
                    meta?.handleDeleteRow?.(row.original);
                }}
                editUrl={routes.settings.services.edit(row.original.id ?? "")}
                deletePopoverDescription={`Are you sure you want to delete this #${row.original.id} Service?`}
            />
        ),
    }),
];
